/**
 * SaleFormTienda.jsx
 * ─────────────────────────────────────────────────────────────────────────────
 * POS especializado para TIENDA GENERAL.
 * Reutiliza SaleForm pero fuerza isBotica=false y oculta controles
 * exclusivos de farmacia (laboratorio prominente, presentaciones FEFO, etc.).
 *
 * La lógica de negocio (submit, carrito, offline, sync) la mantiene SaleForm.
 * Este wrapper solo ajusta la presentación visual de "tienda".
 * ─────────────────────────────────────────────────────────────────────────────
 */
import React from 'react';
import SaleForm from './SaleForm';

/**
 * SaleFormTienda — wrapper de SaleForm para negocios de tipo tienda_general.
 * Inyecta las props necesarias sin duplicar código de negocio.
 */
const SaleFormTienda = ({ onSaleSuccess, onShowHistory }) => {
    return (
        <SaleForm
            onSaleSuccess={onSaleSuccess}
            onShowHistory={onShowHistory}
            forceTipoNegocio="tienda_general"
        />
    );
};

export default SaleFormTienda;
